import * as React from 'react';
import './overview-box.scss';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'core/redux/store';
import { Overview } from 'core/models/overview/overview';
import axios from 'axios';
import { useRef, useState } from 'react';
import { ApiResult } from 'apis/apiresult';
import { Bar } from 'react-chartjs-2';
import BarChart from 'components/chart/chart';
import { BarElement, CategoryScale, Chart, LinearScale, BarController, Tooltip } from 'chart.js';
import { toShamsi } from 'utils/scripts/date';
import { Order } from 'core/domains/order';
import { toCurrency } from 'utils/scripts/number';

Chart.register(LinearScale, CategoryScale, BarController, BarElement, Tooltip);

const mapState = (state: RootState) => ({
    state: state,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    title: string
    icon?: any
    count: number
    value?: number
    hideCount?: boolean
}


const OverviewBox: React.FC<Props> = (props) => {


    return (
        <>
            {/* <HomeOutlined /> */}
            <div className="overview-box-container">
                <div className="container">
                    <h3>{props.title} {!props.hideCount ? (<span>{toCurrency(props.count)}</span>) : ''}</h3>
                    {
                        props.value ? <span>{toCurrency(props.value)} تومان</span> : <span>{toCurrency(props.count)}</span>
                    }
                </div>
            </div>
        </>
    );
};

export default connector(OverviewBox);
